// Generated by scripts/align_sonatas.ts wtc. Do not edit by hand.
import type { SonataFile } from '../sonatas/types';
import s0 from './json/bwv847.json';
import s1 from './json/bwv848.json';
import s2 from './json/bwv849.json';
import s3 from './json/bwv850.json';
import s4 from './json/bwv851.json';
import s5 from './json/bwv852.json';
import s6 from './json/bwv853.json';
import s7 from './json/bwv854.json';
import s8 from './json/bwv855.json';
import s9 from './json/bwv856.json';
import s10 from './json/bwv857.json';
import s11 from './json/bwv858.json';
import s12 from './json/bwv859.json';
import s13 from './json/bwv860.json';
import s14 from './json/bwv861.json';
import s15 from './json/bwv862.json';
import s16 from './json/bwv863.json';
import s17 from './json/bwv864.json';
import s18 from './json/bwv865.json';
import s19 from './json/bwv866.json';
import s20 from './json/bwv867.json';
import s21 from './json/bwv868.json';
import s22 from './json/bwv869.json';

/** Preludes of The Well-Tempered Clavier, Book I (2–24) that passed the alignment gate, in order (compact; decode with ../chorales/codec.ts). */
export const WTC_FILES = [s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22] as unknown as SonataFile[];
